<script lang="ts">
interface Props {
    label?: string;
    children?: import('svelte').Snippet;
    hideBlock?: boolean;
}

let { label = '', children, hideBlock = false }: Props = $props();
</script>

{#if !hideBlock}
    <section class="service-callout-container">
        {#if label}
            <p class="service-callout-container__label">{label}</p>
        {/if}
        <div class="service-callout-container__items">
            {@render children?.()}
        </div>
    </section>
{/if}

<style lang="scss">
    .service-callout-container {
        display: flex;
        flex-direction: column;
        gap: 1.6rem;
    }

    .service-callout-container__label {
        color: var(--colour-grey);
        font-size: 1.4rem;
        line-height: 1.2;
        margin: 0;
    }

    .service-callout-container__items {
        display: flex;
        flex-direction: column;
        gap: 1.6rem;
    }
</style>
